<button
  type="button"
  class="sidebar-brand btn border-0 bg-transparent d-flex align-items-center gap-2 mb-0 px-1 pt-1 me-auto text-start"
  @click="$emit('brand-click')"
  aria-label="Open Portfolio Comparisons"
>

  <!-- Short Logo -->
  <div class="sidebar-brand-logo sidebar-logo mb-2 rounded-3"></div>


  <!-- Brand Title + Subtitle -->
  <div class="sidebar-brand-copy d-flex flex-column mt-2">
    <p class="brand-title text-white text-uppercase fw-light text-xs fw-bold mb-1">{{ title }}</p>
    <p class="brand-subtitle text-white-50 text-uppercase fw-light text-xxs">{{ subtitle }}</p>
  </div>

</button>
